const OutdoorArea = Object.freeze({
  BALCONY: 'BALCONY',
  TERRACE: 'TERRACE',
  TERRACE_WITH_GARDEN: 'TERRACE_WITH_GARDEN',
  GARDEN: 'GARDEN'
})

export default OutdoorArea
